module.exports = __webpack_public_path__ + "static/img/code3.996b3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code3.png
// module id = Tetu
// module chunks = 128